import { FC, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, FormInstance } from 'antd';
import cc from 'classcat';
import styled from 'styled-components';
import { ModalPadding, ModalWidth, ZINDEX_MODAL } from 'utils/constants/app/ui';
import { isMobile } from 'utils/is-mobile';
import { Modal, ModalButtons } from 'components/Modal';
import { Button } from 'newcomponents/UI/Button';

const Description = styled.p`
  margin: 12px auto 24px;
  text-align: center;
  color: var(--v3-black-85);
  font-size: 14px;
`;

type Props = {
  title: string;
  description: string;
  Image:
    | {
        lib: string;
        name: string;
        theme: string;
        size?: number;
      }
    | false;
  visible: boolean;
  onCancel: (visible: boolean) => void;
  onFinish: (values: any) => void;
  Input?: ReactElement;
  singleButton?: boolean;
  enableAutocomplete?: boolean;
  classname?: string;
  width?: number;
  form?: FormInstance<any>;
};

export const ModalWithInput: FC<Props> = ({
  title,
  description,
  Input,
  Image,
  visible,
  onCancel,
  onFinish,
  enableAutocomplete,
  singleButton = false,
  classname,
  width,
  form
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      className={cc([{ [`${classname}`]: !!classname }])}
      renderInBody
      zIndex={ZINDEX_MODAL}
      visible={visible}
      title={title}
      align="center"
      image={Image}
      padding={isMobile() ? ModalPadding.MOBILE_12 : ModalPadding.DESKTOP_24}
      width={
        width || (isMobile() ? ModalWidth.MOBILE_350 : ModalWidth.DESKTOP_468)
      }
      centered
      onCancel={() => onCancel(false)}
    >
      <Description>{description}</Description>
      <Form
        {...(form && { form })}
        form={form}
        onFinish={onFinish}
        size="large"
        {...(!enableAutocomplete && { autoComplete: 'off' })}
      >
        <input
          style={{ display: 'none' }}
          type="text"
          name="fakeInputForAutofill"
        />
        {Input}
        <ModalButtons>
          {!singleButton && (
            <Button type="cancel" size="large" onClick={() => onCancel(false)}>
              {t('account.cancel')}
            </Button>
          )}
          <Button type="primary" size="large" htmlType="submit">
            {t('account.submit')}
          </Button>
        </ModalButtons>
      </Form>
    </Modal>
  );
};
